import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import PaperDraggable from "../../../../../../components/PaperDraggable";
import { TDialogFilters } from "..";
import { useState } from "react";
import DateComIntervalo from "../../../../../../components/DateComIntervalo";
import SelectPublico from "../../../../../../components/SelectsSimpleApiQuery/SelectPublico";


export default function FiltroModal({
    open,
    filters: dialogFilters,
    handleFilterSubmit,
    onClearFilters,
    handleClose,
}: FiltroModalProps) {

    const [filters, setFilters] = useState<TDialogFilters>(dialogFilters);

    //funções manipuladoras
    const handleChangeFilters = (prop: keyof TDialogFilters, value: any) => {
        if (value === "") {
            value = null;
        }
        setFilters((prevState) => ({
            ...prevState,
            [prop]: value,
            pagina: 0,
            porPagina: 10,
        }));
    };

    return (
        <Dialog
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            id="draggable-dialog-title"
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle sx={{ cursor: "move" }}>Filtros</DialogTitle>

            <DialogContent>
                <Grid container spacing={2} sx={{ py: 2 }}>
                    <Grid size={{ xs: 12 }}>
                        <SelectPublico
                            value={filters.publico}
                            onChange={(valor) => handleChangeFilters("publico", valor)}
                        />
                    </Grid>

                    <Grid size={{ xs: 12 }}>
                        <DateComIntervalo
                            data={{
                                inicial: filters.data_recibo_inicio,
                                final: filters.data_recibo_fim
                            }}
                            onChangeData={(data) => {
                                handleChangeFilters("data_recibo_inicio", data.inicial)
                                handleChangeFilters("data_recibo_fim", data.final)
                            }}
                            datePickerView={['year', 'month', 'day']}
                            formatString="DD/MM/YYYY"
                            labelInput="Data do recibo"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        onClearFilters();
                        handleClose();
                    }}
                >
                    Limpar
                </Button>

                <Button
                    autoFocus
                    variant="contained"
                    onClick={() => {
                        handleFilterSubmit(filters);
                        handleClose();
                    }}
                >
                    Filtrar
                </Button>
            </DialogActions>

        </Dialog>
    )
}

interface FiltroModalProps {
    open: boolean;
    filters: TDialogFilters;
    handleClose: () => void;
    handleFilterSubmit: (form: TDialogFilters) => void;
    onClearFilters: () => void;
}